import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../../i18n/i18n';
import { Button, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { SketchPicker } from 'react-color';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//  import InputLabel from '@material-ui/core/InputLabel';
import { setInitialState, addMaterialSubgroup, getMaterialGroup } from '../../../actions/resources/MaterialActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Modal from '@material-ui/core/Modal';
import DialogTitle from '@material-ui/core/DialogTitle';
export class AddMaterialSubgroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            materialSubgroupObj: this.props.materialSubgroupObj,
            openModal: false,
            displayColorPicker: false
        }
    }

    componentDidMount() {
        if (this.props.materialGroupDropdown.length == 0) {
            this.props.getMaterialGroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.materialSubgroupPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('materialSubgroupPostingFailed');
        }
    }

    addMaterialSubgroup() {
        if (this.state.materialSubgroupObj.naziv
            && this.state.materialSubgroupObj.id_materijal_grupa) {
            this.props.addMaterialSubgroup(
                this.state.materialSubgroupObj
            )

        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
        }
    }

    handleChangeComplete = (color) => {
        let obj = Object.assign({}, this.state.materialSubgroupObj);
        obj.boja = color.hex;
        this.setState({ materialSubgroupObj: obj });
    };

    handleChangeValue = name => event => {
        let obj = Object.assign({}, this.state.materialSubgroupObj);
        obj[name] = event.target.value;
        this.setState({ materialSubgroupObj: obj });
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker, openModal: !this.state.openModal })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false, openModal: false })
    };

    render() {
        let group = [];
        if (this.props.materialGroupDropdown && !this.props.groupFetching) {
            group = this.props.materialGroupDropdown.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        return (
            <div style={{ padding: 20 }}>

                {/* <Paper className="roundedBoxMaterial" zdepth={4}> */}
                <Dialog
                    open={this.props.add}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="xs"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{this.props.edit ? i18n.t('Edit material subgroup') : i18n.t('Add material subgroup')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-material-subgroup">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16}>
                                <Grid item>
                                    <TextField
                                        select
                                        label={i18n.t('Material group name')}
                                        value={this.state.materialSubgroupObj.id_materijal_grupa}
                                        onChange={this.handleChangeValue('id_materijal_grupa')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        required
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    >
                                        <option value='' />
                                        {group}
                                    </TextField>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        required
                                        label={i18n.t('Title')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.materialSubgroupObj.naziv}
                                        onChange={this.handleChangeValue('naziv')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Icon name')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.materialSubgroupObj.ime_ikonice}
                                        onChange={this.handleChangeValue('ime_ikonice')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Priority')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.materialSubgroupObj.prioritet}
                                        onChange={this.handleChangeValue('prioritet')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Color')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px', backgroundColor: this.state.materialSubgroupObj.boja && this.state.materialSubgroupObj.boja.includes('#') ? `${this.state.materialSubgroupObj.boja}` : `#${this.state.materialSubgroupObj.boja}` }}
                                        onClick={this.handleClick}
                                        value={this.state.materialSubgroupObj.boja}
                                    >
                                    </TextField>
                                    {this.state.displayColorPicker ? <div style={{
                                        position: 'absolute',
                                        zIndex: '2',
                                    }}>
                                        <Modal
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            open={this.state.openModal}
                                            onClose={this.handleClose}
                                            style={{
                                                position: 'absolute',
                                                left: '50%',
                                                top: '50%',
                                                right: '50%',
                                                bottom: '50%',
                                            }}
                                        >
                                            <SketchPicker color={this.state.materialSubgroupObj.boja != null ? this.state.materialSubgroupObj.boja : ''} onChange={this.handleChangeComplete} />
                                        </Modal>
                                    </div> : null}
                                </Grid>
                                <Grid item xs>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#58B4E5', color: 'white' }}
                                        onClick={() => this.addMaterialSubgroup()}
                                    >
                                        {this.props.edit ? i18n.t('Save') : i18n.t('Add')}
                                    </Button>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
                {/* </Paper> */}
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        materialGroupDropdown: state.materialReducer.materialGroupDropdown,
        groupFetching: state.materialReducer.groupFetching,
        groupFetchingFailed: state.materialReducer.groupFetchingFailed,
        materialSubgroupPosting: state.materialReducer.materialSubgroupPosting,
        materialSubgroupPostingFailed: state.materialReducer.materialSubgroupPostingFailed,
        materialSubgroupObj: state.materialReducer.materialSubgroupObj
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getMaterialGroup: () => dispatch(getMaterialGroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addMaterialSubgroup: (materialSubgroupObj) => dispatch(addMaterialSubgroup(materialSubgroupObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddMaterialSubgroup)